// 提取通用功能
function getSelectedValues() {
    const elements = document.querySelectorAll(".t4s-dib.t4s-swatch__current");
    if (elements.length === 0) {
        console.log("Cannot find matched elements");
        return null;
    }
    
    return Array.from(elements).map(element => element.textContent.trim()).join(" / ");
}

function handleElementsUpdate() {
    const result = getSelectedValues();
    if (result) {
        // console.log(result);
        updateFiveDescription(result);
    }
}

// 主功能
document.addEventListener("DOMContentLoaded", function () {
    // 初始检查
    handleElementsUpdate();
    
    // 设置观察者
    const observer = new MutationObserver(() => handleElementsUpdate());
    const config = {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
    };
    
    const targetNode = document.querySelector(".t4s-swatch");
    if (targetNode) {
        observer.observe(targetNode, config);
    } else {
        console.log("Cannot find watch target element");
    }
    
    // 移动端查看更多功能
    const fullLists = document.querySelectorAll(".five-point-list");
    const isMobile = window.matchMedia("(max-width: 16880px)").matches;
    
    if (isMobile) {
        fullLists.forEach((fullList) => {
            const seeMoreBtn = fullList.nextElementSibling;
            const items = fullList.querySelectorAll("li");
            
            // 初始状态
            for (let i = 1; i < items.length; i++) {
                items[i].style.display = "none";
            }
            seeMoreBtn.style.display = "block";
            
            // 事件处理
            seeMoreBtn.addEventListener("click", function () {
                const isExpanded = seeMoreBtn.textContent === "See less";
                
                // 切换显示
                for (let i = 2; i < items.length; i++) {
                    items[i].style.display = isExpanded ? "none" : "list-item";
                }
                
                // 更新按钮状态
                seeMoreBtn.textContent = isExpanded ? "See more" : "See less";
                seeMoreBtn.classList.toggle("see-less", !isExpanded);
            });
        });
    }
});

// 更新显示函数
function updateFiveDescription(result) {
    const couponContainers = document.querySelectorAll(".JC-LGL-five-point-container");
    
    couponContainers.forEach(container => {
        container.style.display = "none";
    });
    
    const matchingContainer = document.querySelector(`.JC-LGL-five-point-container[data-variant-title="${result}"]`);
    if (matchingContainer) {
        matchingContainer.style.display = "block";
    } else {
        console.log("Cannot find matching five-point container");
    }
}

// 图片切换功能
function changeImage(imageSrc) {
    const productImage = document.getElementById('productImage');
    if (productImage) {
        productImage.src = imageSrc;
    }
}



document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('.slider');
    const dots = document.querySelectorAll('.dot');
    const prevButton = document.querySelector('.nav-button.prev');
    const nextButton = document.querySelector('.nav-button.next');
    const playButtons = document.querySelectorAll('.play-button');
    let currentIndex = 0;

    // 显示指定索引的幻灯片
    function showSlide(index) {
        // 隐藏所有幻灯片
        sliders.forEach(slider => {
            slider.classList.remove('active');
        });
        
        // 移除所有点的激活状态
        dots.forEach(dot => {
            dot.classList.remove('active');
        });
        
        // 暂停所有视频
        const videos = document.querySelectorAll('video');
        videos.forEach(video => {
            video.pause();
            video.currentTime = 0;
        });
        
        // 重置所有播放按钮
        playButtons.forEach(btn => {
            btn.classList.remove('hidden');
        });
        
        // 显示当前幻灯片和激活对应的点
        sliders[index].classList.add('active');
        dots[index].classList.add('active');
        currentIndex = index;
    }

    // 下一张
    function nextSlide() {
        let newIndex = (currentIndex + 1) % sliders.length;
        showSlide(newIndex);
    }

    // 上一张
    function prevSlide() {
        let newIndex = (currentIndex - 1 + sliders.length) % sliders.length;
        showSlide(newIndex);
    }

    // 绑定上一张按钮
    prevButton.addEventListener('click', prevSlide);

    // 绑定下一张按钮
    nextButton.addEventListener('click', nextSlide);

    // 绑定点击圆点切换
    dots.forEach((dot, index) => {
        dot.addEventListener('click', function() {
            showSlide(index);
        });
    });

    // 视频播放按钮功能
    playButtons.forEach((button, index) => {
        button.addEventListener('click', function() {
            const video = document.getElementById('video' + index);
            if (video) {
                video.play();
                button.classList.add('hidden');
            }
        });
    });

    // 视频播放时隐藏播放按钮，暂停时显示
    const videos = document.querySelectorAll('video');
    videos.forEach((video, index) => {
        video.addEventListener('play', function() {
            playButtons[index].classList.add('hidden');
        });
        
        video.addEventListener('pause', function() {
            playButtons[index].classList.remove('hidden');
        });
        
        video.addEventListener('ended', function() {
            playButtons[index].classList.remove('hidden');
        });
    });

    // 可选：自动播放功能（每5秒切换一次）
    // 取消注释下面的代码启用自动播放
    /*
    let autoPlayInterval = setInterval(nextSlide, 5000);
    
    // 鼠标悬停时暂停自动播放
    const sliderContainer = document.querySelector('.slider-container');
    sliderContainer.addEventListener('mouseenter', function() {
        clearInterval(autoPlayInterval);
    });
    
    sliderContainer.addEventListener('mouseleave', function() {
        autoPlayInterval = setInterval(nextSlide, 5000);
    });
    */

    // 键盘控制（左右箭头键）
    document.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
            prevSlide();
        } else if (e.key === 'ArrowRight') {
            nextSlide();
        }
    });

    // 触摸滑动支持（移动端）
    let touchStartX = 0;
    let touchEndX = 0;
    
    const sliderContainer = document.querySelector('.slider-container');
    
    sliderContainer.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
    });
    
    sliderContainer.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
    });
    
    function handleSwipe() {
        if (touchEndX < touchStartX - 50) {
            // 向左滑动
            nextSlide();
        }
        if (touchEndX > touchStartX + 50) {
            // 向右滑动
            prevSlide();
        }
    }
});

